import React, { useEffect, useMemo } from "react";
import FieldRenderer from "../../Form/FieldRenderer";
// import { APICONSTANT } from "../utils/api/Config";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedDistrict,
  setSelectedDistrictCode,
  setSelectedDivision,
  setSelectedDivisionCode,
  setSelectedRegion,
  setSelectedRegionCode,
  setSelectedTaluk,
  setSelectedTalukCode,
  setSelectedVillage,
  setSelectedVillageCode,
} from "./store";
import { APICONSTANT } from "../../../utils/api/Config";
import { postFetchData } from "../../../utils/api/FetchData";
import CustomHookForFilter from "./CustomHookForFilter";

function DistrictDetails({ ...props }) {
  const dispatch = useDispatch();
  const districtDetails = useSelector((state: RootState) => state.district);
  const { DistrictDetailsHandleChange, details } = CustomHookForFilter();

  const stateAndApiData = [
    [setSelectedRegion, setSelectedRegionCode],
    [setSelectedDistrict, setSelectedDistrictCode],
    [setSelectedDivision, setSelectedDivisionCode],
    [setSelectedTaluk, setSelectedTalukCode],
  ];

  // const DistrictDetailsHandleChange = async (
  //   name,
  //   values,
  //   url,
  //   fun
  //   // selectedCodeFun
  // ) => {
  //   //  dispatch(fun(values));
  //   const requestData = {
  //     region_code: districtDetails?.region_code,
  //     district_code: districtDetails?.district_code,
  //     division_code: districtDetails?.division_code,
  //     taluk_code: districtDetails?.taluk_code,
  //     village_code: districtDetails?.village_code,
  //   };
  //   details(url, requestData, fun);
  // };

  // const details = async (url, requestData, fun, selectedCodeFun) => {
  //   const response = await postFetchData(1, dispatch, url, requestData ?? []); // Use dynamic API URL
  //   if (response?.status === 1) {

  //     if (response?.data?.length !== 0) {
  //       dispatch(fun([{ id: "0", name: "All" }, ...response?.data]));
  //       if (requestData.length == 0) {
  //         dispatch(selectedCodeFun(response?.data?.map((item: any) => item.id)));
  //       }
  //     }

  //   }
  // };

  const initial = async () => {
    if (districtDetails?.district_code) {
      // if (districtDetails?.region_code) {
      //   await DistrictDetailsHandleChange(
      //     "name",
      //     "values",
      //     APICONSTANT.region_list,
      //     setSelectedRegion
      //   );
      // }
      await DistrictDetailsHandleChange(
        "name",
        "values",
        APICONSTANT.district_list,
        setSelectedDistrict
      );
    }
  };

  const InitialLoading = () => {
    const apiCalls = [
      [APICONSTANT.region_list, setSelectedRegion, setSelectedRegionCode],
    ];

    Promise.all(
      apiCalls.map(([url, setData, setCode]) => details(url, [], setData))
    );
  };

  useEffect(() => {
    InitialLoading();
    initial();
  }, []);

  const formConfig = useMemo(
    () => [
      {
        name: "region_code",
        //  label: "Region",
        options: districtDetails?.region_data || [],
        placeholder: "Region",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.district_list,
        setSelectedCode: setSelectedRegionCode,
        onMenuClose: (name, values, apiUrl, fun, codeFun) =>
          DistrictDetailsHandleChange(
            name,
            values,
            apiUrl,
            setSelectedDistrict
          ),

        defaultCode: districtDetails?.region_code ?? "",
        isDisabled: false,
      },
      {
        name: "district_code",
        //  label: "District",
        options: districtDetails?.district_data || [],
        placeholder: "District",
        multiple: true,
        category: "dropDown",
        // apiUrl: APICONSTANT.division_list,
        apiUrl: APICONSTANT.taluk_list,

        setSelectedCode: setSelectedDistrictCode,
        onMenuClose: (name, values, apiUrl, fun) =>
          DistrictDetailsHandleChange(name, values, apiUrl, setSelectedTaluk),
        defaultCode: districtDetails?.district_code,
        isDisabled: false,
      },
      // {
      //   name: "division_code",
      //   //  label: "Division",
      //   options: districtDetails?.division_data || [],
      //   placeholder: "Division",
      //   multiple: true,
      //   category: "dropDown",
      //   apiUrl: APICONSTANT.taluk_list,
      //   setSelectedCode: setSelectedDivisionCode,
      //   onMenuClose: (name, values, apiUrl, fun) =>
      //     DistrictDetailsHandleChange(name, values, apiUrl, setSelectedTaluk),
      //   defaultCode: districtDetails?.division_code,
      //   isDisabled: false,
      // },
      {
        name: "taluk_code",
        //  label: "Taluk",
        options: districtDetails?.taluk_data || [],
        placeholder: "Taluk",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.village_list,
        setSelectedCode: setSelectedTalukCode,
        //DOTO
        onMenuClose: (name, values, apiUrl, fun) =>
          DistrictDetailsHandleChange(name, values, apiUrl, setSelectedVillage),
        defaultCode: districtDetails?.taluk_code,
        isDisabled: false,
      },

      {
        name: "town_village_code",
        //  label: "Town/Village",
        options: districtDetails?.village_data || [],
        placeholder: "Town/Village",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.village_list,
        setSelectedCode: setSelectedVillageCode,

        onMenuClose: (name, values, apiUrl, fun) =>
          DistrictDetailsHandleChange(name, values, apiUrl, setSelectedVillage),
        defaultCode: districtDetails?.taluk_code,
        isDisabled: false,
      },
    ],
    [
      districtDetails?.district_data,
      districtDetails?.region_data,
      districtDetails?.division_data,
      districtDetails?.taluk_data,
      districtDetails?.village_data,
      districtDetails?.region_code,
      districtDetails?.district_code,
      districtDetails?.division_code,
      districtDetails?.taluk_code,
      districtDetails?.village_code,
    ]
  );
  // if (isLoading) return <p>Loading...</p>;
  // if (error) return <p className="text-red-500">Failed to load districts</p>;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {formConfig.map((field, index) => (
        <div key={index} className="">
          <FieldRenderer field={field} />
        </div>
      ))}
      {/* <ApplyAndReset
        renderAbleId={props?.renderAbleId?.main_filterable}
        stateAndApiData={stateAndApiData}
      /> */}
    </div>
  );
}

export default DistrictDetails;
